// import { Component, OnInit } from '@angular/core';
import {
  Component,
  AfterViewInit,
  EventEmitter,
  OnDestroy,
  Input,
  Output,
  SimpleChange
} from '@angular/core';

import 'tinymce';

import 'tinymce/plugins/table';
import 'tinymce/plugins/link';
import 'tinymce/plugins/code';

declare var tinymce: any;
@Component({
  selector: 'app-tiny-editor-login',
  template: `<textarea id="{{loginelementId}}"></textarea>`
})
export class TinyEditorLoginComponent implements AfterViewInit, OnDestroy {

  constructor() { }

  ngOnInit() {
    
  }
  @Input() loginelementId: string;
  @Output() onEditorContentChange = new EventEmitter();
  @Input() logineditedData:any;
  editor;
 
  ngOnChanges(changes:SimpleChange){
    // console.log("LOGIN EDITDATA",this.logineditedData);
    if(this.editor != undefined){
    if (this.logineditedData){
    this.editor.setContent(this.logineditedData);
    }

  }
  
  
  }
  ngAfterViewInit() {
    
    tinymce.init({
      selector: '#' + this.loginelementId,
      // plugins: ['link', 'table'],
      plugins: ['code'],
      skin: 'oxide',
      
      toolbar: "undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | code",

      setup: editor => {

        this.editor = editor;
        editor.on('keyup change', () => {
          this.logineditedData="";
          // console.log("bb",this.logineditedData);
          const content = editor.getContent();
          this.onEditorContentChange.emit(content);
        });

        editor.on('init', () =>
                {
                  // console.log("AA",this.logineditedData);
                    if (this.logineditedData)
                    {
                        editor.setContent(this.logineditedData);
                    }
                });
      }
    });
  }

  ngOnDestroy() {
    tinymce.remove(this.editor);
  }
}
